import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import ajaxProject from "../../util/remote/ajaxProject";
import Loader from "../../Components/Common/Loader";
import AppContainer from "../../Components/Structure/AppContainer";
import useStateCallback from "../../util/customHooks/useStateCallback";
import AddCross from "../../Components/ProjectTracker/AddCross";
import UpdateCross from "../../Components/ProjectTracker/UpdateCross";
import TableHeader from "../../Components/Common/TableHeader";
import * as XLSX from "xlsx"; // Import xlsx library
import jsPDF from "jspdf";
import "jspdf-autotable";

function ListCrossesProducts() {
  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState(false);
  const { batch, id } = useParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(false);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState("");

  const [modal, setModal] = useStateCallback(false);

  const handleModal = () => {
    setModal(false, () =>
      setModal(
        <AddCross id={id} batch={batch} f={listProducts} isOpen={true} />
      )
    );
  };

  const handleModal2 = (e, item) => {
    setModal(false, () =>
      setModal(
        <UpdateCross
          id={id}
          cross_id={item.id}
          batch={batch}
          f={listProducts}
          isOpen={true}
          wkt_geom={item.wkt_geom}
          fid={item.fid}
          name={item.name}
          cable_attachment={item.cable_attachment}
          initial_length={item.initial_length}
          trunk={item.trunk}
          location={item.location}
          contractor={item.contractor}
        />
      )
    );
  };

  useEffect(() => {
    SearchCrosses();
  }, [searchQuery, batch]);

  const SearchCrosses = async () => {
    setLoading(true);
    const server_response = await ajaxProject.searchCrosses(searchQuery);
    setLoading(false);
    if (searchQuery.length > 0) {
      if (server_response.status === "OK") {
        setProductList(server_response.details);
      } else {
        setProductList(server_response.details);
      }
    } else {
      setLoading(true);
      const server_response = await ajaxProject.fetchCrossesBatchProducts(
        batch
      );
      setLoading(false);

      if (server_response.status === "OK") {
        setProductList(server_response.details);
      }
    }
  };

  const listProducts = async () => {
    setLoading(true);
    const server_response = await ajaxProject.fetchCrossesBatchProducts(batch);
    setLoading(false);

    if (server_response.status === "OK") {
      setProductList(server_response.details);
    }
  };

  const exportToExcel = () => {
    // Prepare data for export
    if (Array.isArray(productList)) {
      const data = productList.map((item, index) => ({
        wkt_geom: item.wkt_geom,
        fid: item.fid,
        name: item.name,
        cable_attachment: item.cable_attachment,
        id_neighborhood: item.id_neighborhood,
        trunk: item.trunk,
        location: item.location,
        contractor: item.contractor,
        initial_length: item.initial_length,
        current_length: item.current_length,
        acceptance_date: item.acceptance_date,
        status: item.status,
        install_date: item.install_date,
      }));
      // Create a worksheet from your table data
      const ws = XLSX.utils.json_to_sheet(data);

      // Create a workbook with the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Crosses");

      // Generate a file name
      const fileName = "crosses_data.xlsx";

      // Save the file
      XLSX.writeFile(wb, fileName);
    } else {
      toast.error("Cannot export empty table to excel");
    }
  };

  return (
    <AppContainer title="Batch Crosses List">
      <>
        <Toaster position="top-center" reverseOrder={false} />
        {modal}
        <Link
          to={`/project/crosses/${id}`}
          className="btn btn-primary btn-sm mb-2">
          Back To Crosses
        </Link>
        <div className="mt-4 mb-4">
          <div class="input-group">
            <input
              class="form-control"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search for..."
              type="text"
            />
            <span class="input-group-btn">
              <button
                class="btn ripple btn-primary"
                style={{
                  height: 26,
                  borderTopRightRadius: 25,
                  borderBottomRightRadius: 25,
                }}
                type="button">
                <span class="input-group-btn">
                  <i class="fa fa-search"></i>
                </span>
              </button>
            </span>
          </div>
        </div>
        <div className="card custom-card">
          <div className="card-body map-card">
            <button
              style={{ float: "right" }}
              onClick={exportToExcel}
              className="btn btn-sm btn-secondary mb-3 ml-3 mr-3">
              Export to Excel
            </button>
            <TableHeader
              title="Upload Batch Products"
              viewButton={
                <a
                  href="#"
                  onClick={handleModal}
                  className="btn btn-primary btn-sm"
                  style={{ float: "right" }}>
                  Add Cross
                </a>
              }
            />

            <div className="table-responsive">
              <div className="border-top mt-3"></div>
              {loading && <Loader />}
              {!loading && (
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>wkt_geom</th>
                      <th>fid</th>
                      <th>name</th>
                      <th>cable_attachment</th>
                      <th>trunk</th>
                      <th>location</th>
                      <th>contractor</th>
                      <th>initial_length</th>
                      <th>current_length</th>
                      <th>acceptance_date</th>
                      <th>status</th>
                      <th>install_date</th>
                      <th>edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!Array.isArray(productList) && <tr>No crosses found</tr>}
                    {Array.isArray(productList) &&
                      productList.map((item, key) => (
                        <tr key={key}>
                          <td>{item.wkt_geom}</td>
                          <td>{item.fid}</td>
                          <td>{item.name}</td>
                          <td>{item.cable_attachment}</td>
                          <td>{item.trunk}</td>
                          <td>{item.location}</td>
                          <td>{item.contractor}</td>
                          <td>{item.initial_length}</td>
                          <td>{item.current_length}</td>
                          <td>{item.acceptance_date}</td>
                          <td>{item.status}</td>
                          <td>{item.install_date}</td>
                          <td>
                            <a
                              onClick={(e) => handleModal2(e, item)}
                              className="btn btn-primary btn-sm">
                              Edit
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </>
    </AppContainer>
  );
}

export default ListCrossesProducts;
